var React = require('react');

function CartIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a-cart-icon","d":"M0 0h27.93v22.803H0z"})),React.createElement("g",{"fillRule":"evenodd","key":1},React.createElement("path",{"d":"M3.23 15.345L1.802 4.129h21.511l-1.426 11.216H3.231zM27.93 0h-4.093l-.296 2.329H1.791A1.791 1.791 0 00.013 4.346l1.632 12.799h20.011l-.244 1.925H2.099l.33 1.917h3a1.312 1.312 0 102.422 0h9.786a1.312 1.312 0 102.422 0h3.128l2.424-19.07h2.318V0z","mask":"url(#b-cart-icon)"}))]);
}

CartIcon.defaultProps = {"width":"28","height":"23"};

module.exports = CartIcon;

CartIcon.default = CartIcon;
